import { render, staticRenderFns } from "./CargoEditModal.vue?vue&type=template&id=8d863802"
import script from "./CargoEditModal.vue?vue&type=script&lang=js"
export * from "./CargoEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports